import Tab from './Tab'
import Tabs from './Tabs'

export { Tabs }
export default Tab
